import { render, staticRenderFns } from "./Groups.vue?vue&type=template&id=cbf9b806&scoped=true"
import script from "./Groups.vue?vue&type=script&lang=js"
export * from "./Groups.vue?vue&type=script&lang=js"
import style0 from "./Groups.vue?vue&type=style&index=0&id=cbf9b806&prod&lang=scss&scoped=true"
import style1 from "./Groups.vue?vue&type=style&index=1&id=cbf9b806&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf9b806",
  null
  
)

export default component.exports